import axios from '@core_utils/api/_axios';
const { mergeEvSlots } = require('./ev-results-merge.cjs');
const { integrityIssues } = require('./scoring-integrity-error.cjs');
const category3Recipe =     {
    'name': 'Category3',
    'description': 'category3 집합',
    'leaf_verbose': false,
    'base': 'sub_data',
    'group_by': [
        {
            'keys': [
                'campaign_id'
            ],
            'order': [
                {
                    'key': 'campaign_id',
                    'direction': 'asc'
                }
            ]
        },
        {
            'keys': [
                'company_id'
            ],
            'order': [
                {
                    'key': 'company_id',
                    'direction': 'asc'
                }
            ]
        },
        {
            'keys': [
                'category3_question_name',
                'category3_question_code',
                'category3_lft'
            ],
            'order': [
                {
                    'key': 'category3_lft',
                    'direction': 'asc'
                }
            ]
            ,'aggr': [
                {
                    'keys':['ev_code'],
                    'method': {
                        'type':'custom',
                        'function': 'EvCode.aggr'
                    },
                    'name':'ev_code'
                }
            ]
        }
    ],
    'columns': [
        {
            'value_key': 'campaign_id',
            'alias': '캠페인ID'
        },
        {
            'value_key': 'company_id',
            'alias': '업체ID'
        },
        {
            'value_key': 'category3_question_name',
            'alias': '소분류'
        }
        ,{
            'value_key': 'ev_code',
            'alias': '평가코드'
        },
        {
            'value_key': 'category3_question_code',
            'alias': 'question_code'
        }
    ]
};


const evaluations = {
    namespaced: true,
    state: {
        audit_category: [],
        ev_code_list: [],
        evaluation_list: {},
        ev_results: {},
        map_ev_lv_variant: {
            'U': {variant: 'danger', cardClass: 'level-danger'},
            'D': {variant: 'danger', cardClass: 'level-danger'},
            'C': {variant: 'warning', cardClass: 'level-warning'},
            'B': {variant: 'info', cardClass: 'level-normal'},
            'A': {variant: 'success', cardClass: 'level-good'},
            'N': {variant: 'secondary', cardClass: 'level-normal'},
        },
        category3Levels: {},
        // 점수 요약이 해당없음 섞임으로 422 일 때 막힌 문항 목록 (정상이면 null)
        category3IntegrityIssues: null,
    },
    getters: {
        get_audit_category_name: (state) => (item, $i18n) => {
            if ($i18n.locale === 'ko')
                return item.category;
            if ($i18n.locale === 'en')
                return item.category_ea;
            if ($i18n.locale === 'ca')
                return item.category_ca;
            return item.category;
        },
        get_pos_ev_code_options: (state) => {
            return [{value: null, text: '선택안함'}, ...state.ev_code_list
                .filter((item) => {
                    const codeSplit = item.code.split('::');
                    return codeSplit[1] == null;
                }).map((item) => {
                    return {value: item.code, text: item.description};
                })];
        },
        
        get_neg_ev_code_options: (state) => {
            return [{value: null, text: '선택안함'}, ...state.ev_code_list
                .filter((item) => {
                    const codeSplit = item.code.split('::');
                    return codeSplit?.[1] === 'N';
                }).map((item) => {
                    return {value: item.code, text: item.description};
                })];
        },
        mapEvCodeLv: (state) => {
            const mapEv = {};
            state.ev_code_list.forEach((ev) => {
                if (mapEv[ev.aggr_code]) return;
                mapEv[ev.aggr_code] = {description: ev.description};
            });
            
            return mapEv;
        },
        checkEvResultAvailable: (state) => {
            const results = Object.values(state.ev_results);
            return results.some(({ev_results}) => ev_results.length > 0);
        }
    },
    actions: {
        async fetchEvCode({commit}) {
            const response = await axios.get('/evaluation/codes', {
                params: {sub_code: this.sub_code}
            });
            
            commit('set_ev_code_list', response.data);
            
            return response.data;
        },
        async fetchEvList({commit}, {saveStore = true, question_code, template_code, sub_code}) {
            let apiUrl = '';
            if (question_code) {
                apiUrl = `/evaluation/question/${question_code}`;
            } else if (template_code) {
                apiUrl = `/evaluation/template/${template_code}`;
            } else if (sub_code) {
                apiUrl = `/evaluation/${sub_code}`;
            }
            const response = await axios.get(apiUrl);
            if(saveStore){
                commit('set_evaluation_list', response.data);
            }
            return response;
        },
        async fetchEvResults({commit}, {saveStore = true,company_id, campaign_id, sub_code}) {
            // /v3/scoring 은 df_subs(답변행)에서 출발하므로 답변 0건 업체는 items 가 빈 배열이다.
            // 슬롯(캠페인 템플릿 기준, sub_id null)으로 자리를 먼저 만들고 scoring 결과를 sub_code 단위로 덮어쓴다.
            const [slots, response] = await Promise.all([
                axios.get('/v3/scoring/slots', {
                    params: {company_id, campaign_id, sub_code: Array.isArray(sub_code) ? sub_code.join(',') : sub_code}
                }).catch(() => ({data: {items: []}})), // 슬롯 엔드포인트 미배포 백엔드에서는 기존(scoring 만) 동작으로 degrade
                axios.post('/v3/scoring', {
                    company_id,
                    campaign_id,
                    sub_code
                }),
            ]);
            const mapEv = mergeEvSlots(slots.data?.items, response.data.items);
            if(saveStore) {
                commit('set_ev_results', mapEv);
            }

            return {response, mapEv};
        },
        async fetchAuditCategory({commit}) {
            try {
                const response = await axios.get('/evaluation/audit_category');
                const result = response.data?.items ?? [];
                result.unshift({
                    code: null,
                    category: '평가 분류를 선택해주세요.',
                    category_ea: 'Please select an evaluation category.',
                    category_ca: '请选择评分类别。'
                });
                commit('set_audit_category', response.data?.items ?? []);
            } catch (error) {
                console.error('Error fetching available comments:', error);
                commit('set_audit_category', []);
            }
        },
        async createAuditCategory({commit}, id) {
            try {
                const response = await axios.post('/evaluation/audit_category', {
                    id
                });
                commit('set_audit_category', response.data?.items ?? []);
            } catch (error) {
                console.error('Error fetching available comments:', error);
                commit('set_audit_category', []);
            }
        },
        async updateAuditCategory({commit}, id) {
            try {
                const response = await axios.put('/evaluation/audit_category', {
                    id
                });
                commit('set_audit_category', response.data?.items ?? []);
            } catch (error) {
                console.error('Error fetching available comments:', error);
                commit('set_audit_category', []);
            }
        },
        async deleteAuditCategory({commit}, id) {
            try {
                const response = await axios.delete('/evaluation/audit_category', {
                    id
                });
                commit('set_audit_category', response.data?.items ?? []);
            } catch (error) {
                console.error('Error fetching available comments:', error);
                commit('set_audit_category', []);
            }
        },
        setAuditCategory({commit}, comments) {
            commit('set_audit_category', comments);
        },
        async fetchCategory3Aggr({commit}, {project_code, company_id}) {
            try {
                const response = await axios.post('/v3/scoring/summary', {
                    project_code,
                    company_id,
                    recipe: [category3Recipe],
                });
                
                const { result } = response.data;
                
                const levels = {};
                result?.[0].data?.forEach(item => {
                    const {category3_question_code, ev_code} = item;
                    levels[category3_question_code] = ev_code;
                });
                commit('set_category3Levels', levels);
                commit('set_category3IntegrityIssues', null);

                return response.data;
            }
            catch (error) {
                commit('set_category3IntegrityIssues', integrityIssues(error));
            }
        }
    },
    mutations: {
        set_audit_category(state, comments) {
            state.audit_category = comments;
        },
        set_ev_code_list(state, codes) {
            state.ev_code_list = codes;
        },
        set_evaluation_list(state, evaluations) {
            state.evaluation_list = evaluations;
        },
        set_ev_results(state, results) {
            state.ev_results = results;
        },
        set_category3Levels(state, levels) {
            state.category3Levels = levels;
        },
        set_category3IntegrityIssues(state, issues) {
            state.category3IntegrityIssues = issues;
        }
    },
};
export default evaluations;
